import React from "react";

const summaryItems = [
  { label: "A. Número de Karma", key: "A", description: "Mi tarea pendiente", color: "bg-[#b794c0] border-[#9d7fa6] text-white" },
  { label: "B. Número personal", key: "B", description: "¿Quién soy?", color: "bg-[#b794c0] border-[#9d7fa6] text-white" },
  { label: "C. Número de vida pasada", key: "C", description: "¿Quién fui?", color: "bg-[#b794c0] border-[#9d7fa6] text-white" },
  { label: "D. Número de personalidad", key: "D", description: "Mi máscara", color: "bg-[#b794c0] border-[#9d7fa6] text-white" },
  { label: "I. Núm. del subconsciente", key: "I", description: "La guía a mi destino", color: "bg-[#cddc39] border-[#afb42b] text-gray-800" },
  { label: "J. Número del Inconsciente", key: "J", description: "Mi espejo", color: "bg-[#cddc39] border-[#afb42b] text-gray-800" },
  { label: "P. Número de sombra", key: "P", description: "Aspectos ocultos", color: "bg-[#ef5350] border-[#d32f2f] text-white" },
  { label: "O. Número de inconsciente negativo", key: "O", description: "Bloqueos internos", color: "bg-[#ef5350] border-[#d32f2f] text-white" },
  { label: "Q. Ser inferior heredado", key: "Q", description: "Cargas ancestrales", color: "bg-[#ef5350] border-[#d32f2f] text-white" },
  { label: "R. Ser inferior consciente", key: "R", description: "Retos actuales", color: "bg-[#ef5350] border-[#d32f2f] text-white" },
  { label: "S. Ser inferior latente", key: "S", description: "Retos futuros", color: "bg-[#ef5350] border-[#d32f2f] text-white" }
];

const PinnacleResultList = ({ results }) => {
  const getValue = (key) => {
    if (!results) return "—";
    const value = results[key];
    return value === null || value === undefined ? "—" : value;
  };

  return (
    <div className="h-full flex flex-col rounded-2xl bg-white/70 p-5 shadow-inner border border-white/60">
      <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-4">Resumen numerológico</h3>
      <div className="flex-1 overflow-y-auto pr-1 space-y-2">
        {summaryItems.map((item) => (
          <div
            key={item.key}
            className="flex items-center bg-white/70 rounded-xl p-3 shadow-sm border border-gray-100 hover:shadow-md transition-transform hover:-translate-y-[2px]"
          >
            <div
              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold border-4 shadow ${item.color}`}
            >
              {getValue(item.key)}
            </div>
            <div className="ml-4">
              <div className="text-sm font-semibold text-gray-800">{item.label}</div>
              <div className="text-xs text-gray-500">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
      {!results && (
        <p className="text-center text-xs text-gray-400 mt-4">Ingresa una fecha o sincroniza un perfil para ver resultados.</p>
      )}
    </div>
  );
};

export default PinnacleResultList;

